import {dataHooks} from '@wix/data-hooks'

export const cardGuaranteeNoticeDataHooks = dataHooks<{
  root: {}
  paymentPolicyLink: {}
}>('card-guarantee-notice')
